import styled from "styled-components";

const S = {}

S.TopMenuParent = styled.div`
    & .small {
        background: white;
        & a {
            color: #22283B;
        }
        
    }
`;

S.TopMenuWrapper = styled.div`
    background: #fff;
    /* background: #000000ad; */
    z-index: 1;
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.16);
    border-bottom: 1px solid #fff;
    position: fixed;
    width: 100%;
    z-index: 9;
`;

S.TopMenu = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
    position: relative;

    @media (max-width: 1280px) {
        justify-content: space-between;
    }

    @media(min-width: 1440px) {
        & .small-logo {
            left: 80px !important;
        }
    }

    &  .small-logo {
        height: 60px;
        left: 0;
    }
`;

S.NavBtnWrapper = styled.div`
    display: flex;
    align-items: center;
    /* margin-left: 200px; */

    & div {
        margin-right: 30px;
    }

    & .mobile-menu {
        & ul {
            right: 0;
        }
    }

    & .small-navigation {
        & ul {
            height: 60px;
        }
    }
`;

export default S;